import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import ROUTES, { EKYC } from "../../../helpers/constants/routes";
import { getDeviceType } from "../../../utils/CommonFunction";
import { DeviceType } from "../../../helpers/constants/constant";

const PasswordSuccessScreen = () => {
  const history = useHistory();
  const [mobileView, setMobileView] = useState(false);

  useEffect(() => {
    const mobile =
      getDeviceType() === DeviceType.MOBILE ||
      getDeviceType() === DeviceType.TABLET;
    setMobileView(mobile);
  }, []);

  const content = (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "center",
        width: "100%",
        padding: "20px",
      }}
    >
      <div
        style={{
          width: 80,
          height: 80,
          borderRadius: "50%",
          background: "rgba(44, 174, 102, 0.1)",
          border: "2px solid #2CAE66",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 24,
          boxShadow: "0 4px 10px rgba(44, 174, 102, 0.15)",
        }}
      >
        <span style={{ fontSize: 36, color: "#2CAE66", fontWeight: "bold" }}>✓</span>
      </div>

      <h2 style={{ marginBottom: 12, fontSize: 22, fontWeight: "600", color: "#333", fontFamily: "barlow" }}>
        Account Created Successfully
      </h2>

      <p style={{ color: "#666", marginBottom: 30, fontSize: 15, fontFamily: "barlow", maxWidth: "320px", lineHeight: "22px" }}>
        You can now login to your account with your newly set password.
      </p>

      <button
        onClick={() => history.push(EKYC.LOGIN)}
        style={{
          background: "linear-gradient(135deg, #2CAE66 0%, #228b50 100%)",
          color: "#fff",
          border: "none",
          padding: "12px 36px",
          borderRadius: 8,
          fontSize: 16,
          fontWeight: "600",
          cursor: "pointer",
          boxShadow: "0 4px 12px rgba(44, 174, 102, 0.25)",
          transition: "all 0.2s ease",
          fontFamily: "barlow",
          outline: "none",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-1px)";
          e.currentTarget.style.boxShadow = "0 6px 18px rgba(44, 174, 102, 0.35)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(44, 174, 102, 0.25)";
        }}
      >
        Continue to login
      </button>
    </div>
  );

  return mobileView ? (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "90%",
        maxWidth: "440px",
        padding: "2.5rem 1.5rem",
        marginTop: "-30px",
        backgroundColor: "#ffffff",
        borderRadius: "16px",
        boxShadow: "0 10px 25px rgba(0, 0, 0, 0.05)",
        zIndex: 2,
      }}
    >
      {content}
    </div>
  ) : (
    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      {content}
    </div>
  );
};

export default PasswordSuccessScreen;
